import React, { Component } from 'react'
import { Card, FormGroup, Label, Button, Row, Col, Modal, ModalHeader, ModalBody, Form, Input, CardHeader, CardBody, CardText, Badge } from 'reactstrap'
import Fetch from '../../Auxiliares/fetch'
import verImg from '../../Img/openDoc.png'
import { toast } from 'react-toastify'
import { ip } from '../../Auxiliares/ip'
import Banner from '../../Img/Banner.png'


export default class pendienteCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isViewModalOpen: null,
            esExtranjero: false,
            nombre: null,
            ruta: null,
            tipoDoc: 0,
            doc: null,
            isEmailModalOpen: null,
            perfil: null,
            tooltip_solicitud: false,
            tooltip_actaNacimiento: false,
            tooltip_curp: false,
            tooltip_fotografia: false,
            tooltip_pago: false,
            tooltip_certificado: false,
            tooltip_formaExtranjero: false,
            tooltip_contratoEstudiantil: false,
            tooltip_nss: false,
            documentos: [
                { nombre: 'Solicitud de inscripción', ref: null },
                { nombre: 'Acta de nacimiento', ref: null },
                { nombre: 'CURP', ref: null },
                { nombre: 'Documento Institucional', ref: null },
                { nombre: 'Fotografía', ref: null },
                { nombre: 'Formato FMM', ref: null },
                { nombre: 'Contrato estudiantil', ref: null },
                { nombre: 'Número de seguro social', ref: null },
                // { nombre: 'Certificado parcial de licenciatura', ref: null },
                // { nombre: 'Certificado de licenciatura', ref: null },
                // { nombre: 'Dictamen de revalidación o equivalencia de estudios', ref: null }
            ],
            buttonEnabled: false, //loading,
        }
        this.tipoDocumento = this.tipoDocumento.bind(this)
        this.ejecutar = this.ejecutar.bind(this)
        this.cargarPerfil = this.cargarPerfil.bind(this)
        this.abrirDocumento = this.abrirDocumento.bind(this)
        this.estado = this.estado.bind(this)
        this.aceptar = this.aceptar.bind(this)
        this.denegar = this.denegar.bind(this)
        this.cargarPerfil = this.cargarPerfil.bind(this)
        this.correoAspirante = this.correoAspirante.bind(this)
        this.enviar = this.enviar.bind(this)
        this.estadosDocumentosPreview = this.estadosDocumentosPreview.bind(this)
        this.toggleTooltip = this.toggleTooltip.bind(this)
    }

    tipoDocumento(tipoDoc) {
        switch (parseInt(tipoDoc)) {
            case 0: return "CONSTANCIA_TERMINACION_ESTUDIOS";
            case 1: return "HISTORIAL_ACADEMICO";
            case 2: return "CERTIFICADO_PREPARATORIA";
            case 3: return "REVALIDACION_ESTUDIOS";
            case 4: return "CARTA_COMPROMISO";
        }
    }

    aceptar = (curp, index) => {
        switch (index) {
            case 0:
                //solicitud
                Fetch('/api/acceptSolicitudAP', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp })
                })
                    .then(response => {
                        this.cargarPerfil(curp)
                        this.abrirDocumento()
                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            case 1:
                //acta de nacimiento
                Fetch('/api/acceptActaNacimientoAP', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp })
                })
                    .then(response => {
                        this.cargarPerfil(curp)
                        this.abrirDocumento()
                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            case 2:
                //curp
                Fetch('/api/acceptActaCurpAP', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp })
                })
                    .then(response => {
                        this.cargarPerfil(curp)
                        this.abrirDocumento()
                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            case 4:
                //fotografia
                Fetch('/api/acceptFotografiaAP', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp })
                })
                    .then(response => {
                        this.cargarPerfil(curp)
                        this.abrirDocumento()
                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            case 3:
                var nombreDocumento = this.tipoDocumento(this.state.tipoDoc)
                //certificado de bachillerato
                Fetch('/api/acceptDocumentoInstitucionalAP', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp, tipo: nombreDocumento })
                })
                    .then(response => {
                        this.cargarPerfil(curp)
                        this.abrirDocumento()
                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            case 5:
                //forma extranjero
                Fetch('/api/acceptFormaExtranjeroAP', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp })
                })
                    .then(response => {
                        this.cargarPerfil(curp)
                        this.abrirDocumento()
                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            case 6:
                //contrato estudiantil
                Fetch('/api/acceptContratoEstudiantilAP', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp })
                })
                    .then(response => {
                        this.cargarPerfil(curp)
                        this.abrirDocumento()
                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            case 7:
                //nss
                Fetch('/api/acceptNssAP', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp })
                })
                    .then(response => {
                        this.cargarPerfil(curp)
                        this.abrirDocumento()
                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            default:
                break;
        }
    }

    denegar = (curp, index) => {
        switch (index) {
            case 0:
                //solicitud
                Fetch('/api/denySolicitudAP', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp })
                })
                    .then(response => {
                        this.cargarPerfil(curp)
                        this.abrirDocumento()
                        this.correoAspirante(curp, 'Solicitud de inscripcion')
                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            case 1:
                //acta de nacimiento
                Fetch('/api/denyActaNacimientoAP', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp })
                })
                    .then(response => {
                        this.cargarPerfil(curp)
                        this.abrirDocumento()
                        this.correoAspirante(curp, 'Acta de nacimiento')
                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            case 2:
                //curp
                Fetch('/api/denyActaCurpAP', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp })
                })
                    .then(response => {
                        this.cargarPerfil(curp)
                        this.abrirDocumento()
                        this.correoAspirante(curp, 'CURP')
                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            case 4:
                //fotografia
                Fetch('/api/denyFotografiaAP', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp })
                })
                    .then(response => {
                        this.cargarPerfil(curp)
                        this.abrirDocumento()
                        this.correoAspirante(curp, 'Fotografia')
                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            case 3:
                var nombreDocumento = this.tipoDocumento(this.state.tipoDoc)
                //certificado de bachillerato
                Fetch('/api/denyDocumentoInstitucionalAP', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp, tipo: nombreDocumento })
                })
                    .then(response => {
                        this.cargarPerfil(curp)
                        this.abrirDocumento()
                        this.correoAspirante(curp, 'Certificado de bachillerato')
                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            case 5:
                //forma extranjera
                Fetch('/api/denyFormaExtranjeroAP', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp })
                })
                    .then(response => {
                        this.cargarPerfil(curp)
                        this.abrirDocumento()
                        this.correoAspirante(curp, 'Forma extranjera')
                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            case 6:
                //contrato estudiantil
                Fetch('/api/denyContratoEstudiantilAP', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp })
                })
                    .then(response => {
                        this.cargarPerfil(curp)
                        this.abrirDocumento()
                        this.correoAspirante(curp, 'Contrato estudiantil')
                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            case 7:
                //nss
                Fetch('/api/denyNssAP', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp })
                })
                    .then(response => {
                        this.cargarPerfil(curp)
                        this.abrirDocumento()
                        this.correoAspirante(curp, 'Número de servicio social')
                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            default:
                break;
        }
    }

    referenciar(perfil) {
        var doc = this.state.documentos;
        console.log(perfil)

        doc[0].ref = perfil.solicitud;
        doc[1].ref = perfil.acta_nacimiento;
        doc[2].ref = perfil.acta_curp;
        doc[3].ref = perfil.documento_institucional;
        doc[4].ref = perfil.fotografia;
        doc[5].ref = perfil.forma_extranjero;
        doc[6].ref = perfil.contrato_estudiantil;
        doc[7].ref = perfil.nss;

        this.setState({ documentos: doc })
    }

    abrirDocumento(elem, index) {
        if (elem) {
            this.setState({ nombre: elem.nombre, ruta: elem.ref.ruta, doc: index })
        } else {
            this.setState({ nombre: null })
        }
    }

    componentDidMount() {
        this.estadosDocumentosPreview(this.props.curp)
    }

    componentDidUpdate(prevProps) {
        console.log(this.props.ficha)
        if(this.props.ficha !== prevProps.ficha){
            this.setState({buttonEnabled: false})
            this.estadosDocumentosPreview(this.props.curp)
        }
    }

    cargarPerfil(curp) {
        Fetch('/api/getAspirantePerfil', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ curp })
        })
            .then(response => {
                this.setState({ isViewModalOpen: response.data })
                this.referenciar(response.data)
                this.setState({ perfil: response.data })
            })
            .catch(err => {
                switch (err.status) {

                    case 600:
                        console.log('Error inesperado')
                        break;

                    case 605:
                        console.log('Listado de elementos vacia')
                        this.setState({ perfil: null })
                        break;

                    default:
                        break;
                }
            })

    }

    estadosDocumentosPreview(curp) {
        Fetch('/api/getAspirantePerfil', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ curp })
        })
            .then(response => {
                this.setState({ perfil: response.data, buttonEnabled: true })
            })
            .catch(err => {
                switch (err.status) {

                    case 600:
                        console.log('Error inesperado')
                        break;

                    case 605:
                        console.log('Listado de elementos vacia')
                        this.setState({ perfil: null })
                        break;

                    default:
                        break;
                }
            })

    }

    toggleView(curp) {
        if (curp) {
            this.cargarPerfil(curp)
        } else {
            this.setState(({ isViewModalOpen: null }));
        }
    }

    ejecutar(curp, extranjero) {
        this.toggleView(curp)
        this.setState({ esExtranjero: extranjero === 'E' ? true : false })
    }

    setValue(field, ev) {
        this.setState({ [field]: ev.target.value })
    }

    correoAspirante(curp, documento) {
        this.setState({ isEmailModalOpen: curp ? curp : null, documento: documento })
    }

    notificarAspiranteCorreo() {
        this.setState({ disableEnviar: true })
        this.enviar();
    }

    enviar() {
        var curp = this.state.isEmailModalOpen;
        var documento = this.state.documento;
        var mensaje = this.state.mensajeCorreo;

        Fetch('/api/notificarCorreoAspirante', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ curp, documento, mensaje })
        })
            .then(response => {
                this.actualizarLista();
                this.correoAspirante()
                this.setState({ documento: '', mensaje: '', disableEnviar: false })
            })
            .catch(err => {
                this.setState({ documento: '', mensaje: '', disableEnviar: false })

                switch (err.status) {
                    case 600:
                        console.log('Error inesperado')
                        break;
                    case 602:
                        console.log('Este elemento no existe')
                        break;
                    default:
                        break;
                }
            })
    }

    dateToString() {
        var date = new Date(this.props.fechaRegistro);
        return date.toLocaleDateString() + " " + date.toLocaleTimeString();
    }

    toggleTooltip(variable) {
        this.setState(prevState =>
            ({ variable: !prevState.variable })
        )
    }

    estado(e) {
        switch (e) {
            case 'VACIO':
                return <div className="d-inline-block text-secondary">Documento pendiente</div>

            case 'ACEPTADO':
                return <div className="d-inline-block text-success">Documento aceptado</div>

            case 'RECHAZADO':
                return <div className="d-inline-block text-danger">Documento rechazado</div>

            default:
                break;
        }
    }

    render() {
        return (
            <div>

                <Card className="w-100 mt-3">
                    <CardHeader>
                        <Row className="mb-2">
                            <Col xs="12" xl="5">Ficha #{this.props.ficha}</Col>
                            <Col xs="12" xl="7">
                                {this.state.buttonEnabled ? 
                                <Button block onClick={() => this.ejecutar(this.props.curp, this.props.nacionalidad)} className="bg-primary " >Archivo</Button>
                                : 
                                <Button block disabled onClick={() => this.ejecutar(this.props.curp, this.props.nacionalidad)} className="bg-primary " >Archivo</Button>
                                }
                            </Col>
                        </Row>
                        <Row>
                            <Col xs="12">
                                <Badge className={this.state.perfil !== null && this.state.perfil.solicitud ? (this.state.perfil.solicitud.estado === "ACEPTADO" ? "bg-success" : this.state.perfil.solicitud.estado === "RECHAZADO" ? "bg-danger" : this.state.perfil.solicitud.estado === "VACIO" ? "bg-secondary" : this.state.perfil.solicitud.estado === "REVISION" ? "bg-warning" : "bg-primary") : ""} pill> </Badge><a className="ml-2" />
                                <Badge className={this.state.perfil !== null && this.state.perfil.acta_nacimiento ? (this.state.perfil.acta_nacimiento.estado === "ACEPTADO" ? "bg-success" : this.state.perfil.acta_nacimiento.estado === "RECHAZADO" ? "bg-danger" : this.state.perfil.acta_nacimiento.estado === "VACIO" ? "bg-secondary" : this.state.perfil.solicitud.estado === "REVISION" ? "bg-warning" : "bg-primary") : ""} pill> </Badge><a className="ml-2" />
                                <Badge className={this.state.perfil !== null && this.state.perfil.acta_curp ? (this.state.perfil.acta_curp.estado === "ACEPTADO" ? "bg-success" : this.state.perfil.acta_curp.estado === "RECHAZADO" ? "bg-danger" : this.state.perfil.acta_curp.estado === "VACIO" ? "bg-secondary" : this.state.perfil.acta_curp.estado === "REVISION" ? "bg-warning" : "bg-primary") : ""} pill> </Badge><a className="ml-2" />
                                <Badge className={this.state.perfil !== null && this.state.perfil.documento_institucional ? (this.state.perfil.documento_institucional.estado === "ACEPTADO" ? "bg-success" : this.state.perfil.documento_institucional.estado === "RECHAZADO" ? "bg-danger" : this.state.perfil.documento_institucional.estado === "VACIO" ? "bg-secondary" : this.state.perfil.documento_institucional.estado === "REVISION" ? "bg-warning" : "bg-primary") : ""} pill> </Badge><a className="ml-2" />
                                <Badge className={this.state.perfil !== null && this.state.perfil.fotografia ? (this.state.perfil.fotografia.estado === "ACEPTADO" ? "bg-success" : this.state.perfil.fotografia.estado === "RECHAZADO" ? "bg-danger" : this.state.perfil.fotografia.estado === "VACIO" ? "bg-secondary" : this.state.perfil.fotografia.estado === "REVISION" ? "bg-warning" : "bg-primary") : ""} pill> </Badge><a className="ml-2" />
                                <Badge className={this.state.perfil !== null && this.state.perfil.contrato_estudiantil ? (this.state.perfil.contrato_estudiantil.estado === "ACEPTADO" ? "bg-success" : this.state.perfil.contrato_estudiantil.estado === "RECHAZADO" ? "bg-danger" : this.state.perfil.contrato_estudiantil.estado === "VACIO" ? "bg-secondary" : this.state.perfil.contrato_estudiantil.estado === "REVISION" ? "bg-warning" : "bg-primary") : ""} pill> </Badge><a className="ml-2" />
                                <Badge className={this.state.perfil !== null && this.state.perfil.nss ? (this.state.perfil.nss.estado === "ACEPTADO" ? "bg-success" : this.state.perfil.nss.estado === "RECHAZADO" ? "bg-danger" : this.state.perfil.nss.estado === "VACIO" ? "bg-secondary" : this.state.perfil.nss.estado === "REVISION" ? "bg-warning" : "bg-secondary") : ""} pill> </Badge><a className="ml-2" />
                                {this.props.nacionalidad === 'E' ? (<Badge className={this.state.perfil !== null && this.state.perfil.forma_extranjero ? (this.state.perfil.forma_extranjero.estado === "ACEPTADO" ? "bg-success" : this.state.perfil.forma_extranjero.estado === "RECHAZADO" ? "bg-danger" : this.state.perfil.forma_extranjero.estado === "VACIO" ? "bg-secondary" : this.state.perfil.forma_extranjero.estado === "REVISION" ? "bg-warning" : "bg-primary") : ""} pill> </Badge>) : ''}
                            </Col>
                        </Row>
                    </CardHeader>

                    <CardBody className="text-left btn">
                        <CardText><p><div className="d-inline-block font-weight-bold small">Nombre:</div> {this.props.nombre} {this.props.ap_paterno} {this.props.ap_materno}</p></CardText>
                        <CardText><p><div className="d-inline-block font-weight-bold small">Curp:</div> {this.props.curp}</p></CardText>
                    </CardBody>
                </Card>

                <Modal isOpen={this.state.isViewModalOpen !== null} toggle={() => this.toggleView()} className="modal-xl">
                    <ModalHeader
                        style={{
                            background: `url(${Banner}) center`,
                            backgroundSize: 'cover', backgroundPosition: 'center-left',
                        }}
                        toggle={() => this.toggleView()}><h5 className="text-light">{this.state.isViewModalOpen !== null ? this.state.isViewModalOpen.curp : ''}</h5></ModalHeader>
                    <ModalBody>
                        <Row>
                            {this.state.documentos[0].ref !== null ? this.state.documentos.map((elem, index) => (
                                index === 5 && this.state.esExtranjero || index !== 5 ? (
                                    elem.ref != null ? (
                                        <Col className="col-4">
                                            <Card className="w-100 mt-3" style={{ height: '12rem' }}>
                                                <CardHeader>{elem.nombre}</CardHeader>
                                                {elem.ref.estado !== 'REVISION' ? <CardBody className="btn"><CardText><p><div className="d-inline-block font-weight-bold text-left small">Estado:</div> {this.estado(elem.ref.estado)} </p> {elem.ref.notificacion ? <p><div className="d-inline-block font-weight-bold small">Notificacion:</div> {this.estado(elem.ref.estado)} </p> : ''} {/*{Array.from(elem.ref.eventos).length > 0 ? <p><div className="d-inline-block font-weight-bold small">Eventos:</div> <ListGroup>{Array.from(elem.ref.eventos).map(item => (<ListGroupItem>{item.evento} {this.dateToString(item.tiempo)}</ListGroupItem>))}</ListGroup>  </p> : ''}*/} </CardText></CardBody>
                                                    : <CardBody className="btn"> <Button className="mt-3 text-center" onClick={() => this.abrirDocumento(elem, index)}>Evaluar documento</Button> {/* {Array.from(elem.ref.eventos).length > 0 ? <p><div className="d-inline-block font-weight-bold small text-left">Eventos:</div> <ListGroup>{Array.from(elem.ref.eventos).map(item=> ( <ListGroupItem>{item.evento} {this.dateToString(item.tiempo)}</ListGroupItem> ))}</ListGroup>  </p> : ''} */} </CardBody>}
                                            </Card>
                                        </Col>) : '') : ''
                            )) : 'VACIO'}
                        </Row>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.nombre !== null} toggle={() => this.abrirDocumento()} className="modal-xl">
                    <ModalHeader toggle={() => this.abrirDocumento()}>{this.state.nombre !== null ? this.state.nombre : ''}</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col className="justify-content-center text-center">
                                {this.state.nombre == "Documento Institucional" && <FormGroup className="justify-content-center text-center">
                                    <Label>Tipo de documento</Label>
                                    <Input type="select" name="tipoDoc" className="col-12" onChange={this.setValue.bind(this, "tipoDoc")} onKeyPress={this.handleKeyPress} value={this.state.tipoDoc}>
                                        <option value={0}>Constancia de Terminación de Estudios</option>
                                        <option value={1}>Historial Académico</option>
                                        <option value={2}>Cetificado de Preparatoria</option>
                                        <option value={3}>Revalidación de Estudios</option>
                                        <option value={4}>Carta Compromiso</option>
                                    </Input>
                                </FormGroup>
                                }
                                <Card>
                                    <Row>
                                        <Col className="text-center">
                                            <iframe
                                                title="PDF viewer"
                                                width="100%"
                                                height="625"
                                                src={ip + this.state.ruta}>
                                            </iframe>
                                        </Col>
                                    </Row>

                                    <Row className=" text-center">
                                        <Col>
                                            <Button className="btn-success w-100" onClick={() => this.aceptar(this.state.isViewModalOpen !== null ? this.state.isViewModalOpen.curp : 'vacio', this.state.doc !== null ? this.state.doc : 0)}>Confirmar</Button>
                                        </Col>
                                        <Col>
                                            <Button className="btn-secondary w-100" onClick={() => this.denegar(this.state.isViewModalOpen !== null ? this.state.isViewModalOpen.curp : 'vacio', this.state.doc !== null ? this.state.doc : 0)}>Eliminar</Button>
                                        </Col>
                                    </Row>

                                </Card>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.isEmailModalOpen !== null} toggle={() => this.correoAspirante()}
                    className="modal-md">
                    <ModalHeader toggle={() => this.correoAspirante()}>Notificar mediante correo electronico</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <Card className="p-3 text-center">
                                    <Form>
                                        <Row>
                                            <Col>
                                                <Input type="textarea" name="documento" onChange={this.setValue.bind(this, 'mensajeCorreo')} defaultValue={this.state.mensajeCorreo} className="w-100" />
                                            </Col>
                                        </Row>

                                        <Row className="text-center px-3">
                                            <Button name="notificar" value="Enviar" className="w-100 mt-2 bg-info text-light" disabled={this.state.disableEnviar} onClick={this.enviar}>Enviar</Button>
                                        </Row>
                                    </Form>
                                </Card>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>

                {/* <Modal className="pt-5 modal-xl" isOpen={this.state.isViewOpen !== null} toggle={() => this.toggleView()}>
                    <ModalHeader toggle={() => this.toggleView()} className="font-weight-bold">{this.props.documento}</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <Card className="border-0">
                                    <Row>
                                        <Col className="text-center">
                                            <iframe
                                                title="PDF viewer"
                                                width="100%"
                                                height="625"
                                                src={ip + this.props.ubicacion}>
                                            </iframe>
                                        </Col>
                                    </Row>

                                    <Row className=" text-center">
                                        <Col>
                                            <Button className="btn-success w-100" onClick={() => this.aceptar(this.props.id)}>Confirmar</Button>
                                        </Col>
                                        <Col>
                                            <Button className="btn-secondary w-100" onClick={() => this.denegar(this.props.id)}>Eliminar</Button>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>

                <Modal className="pt-5" isOpen={this.state.isDenegateOpen} >
                    <ModalHeader className="font-weight-bold">Notificacion por correo</ModalHeader>
                    <ModalBody>
                        <Card className="border-0">
                            <Form onSubmit={this.notificarCorreo}>
                                <Row>
                                    <Col className="col-4">
                                        <Input type="text" name="noControl" disabled value={this.state.notificarModal_noControl} className="w-100" />
                                    </Col>

                                    <Col>
                                        <Input type="text" name="documento" disabled value={this.state.notificarModal_documento} className="w-100" />
                                    </Col>
                                </Row>

                                <Row className="mt-3 text-center">
                                    <Col>
                                        <Input type="textarea" name="mensaje" className="h-100 w-100" defaultValue={this.state.mensaje} onChange={this.setValue.bind(this, "notificarModal_mensaje")} />
                                    </Col>
                                </Row>

                                <Row className="text-center px-3">
                                    <Button name="notificar" value="Enviar" className="w-100 mt-2 bg-info text-light" disabled={this.state.disable} onClick={this.enviar}>Enviar</Button>
                                </Row>
                            </Form>
                        </Card>
                    </ModalBody>
                </Modal>
                 */}
            </div>
        )
    }
}
